import {
  configureStore,
  combineReducers,
  Reducer,
} from "@reduxjs/toolkit";
import drawerReducer, { iDrawerState } from "src/store/features/drawerSlice";
import appbarReducer, { iAppbarState } from "src/store/features/appbarSlice";
import settingReducer, { iSettingState } from "src/store/features/settingSlice";
import assistantDockReducer, { iAssistantDockState } from "src/store/features/ai-chat/assistantDockSlice";
import logSliceReducer, {iLoginState} from 'src/store/features/user/login/loginSlice';
import createAccountSliceReducer, { iCreateAccountState } from "src/store/features/user/credit/createAccountSlice";
import userInfoSliceReducer , {iAuthInfoState} from 'src/store/features/user/authInfoSlice';
import logoutSliceReducer, { iLogoutState } from "src/store/features/user/login/logoutSlice";
import checkAdminSliceReducer, { iCheckAdminState } from "src/store/features/admin/checkAdminSlice";
import checkUserSliceReducer, { iCheckUserListState } from "src/store/features/admin/checkUserListSlice";
import confirmActiveUserSliceReducer, { iConfirmActiveUserState } from "src/store/features/admin/confirmActiveUserSlice";
import confirmPassiveUserSliceReducer, { iConfirmPassiveUserState } from "src/store/features/admin/confirmPassiveUserSlice";
import grantAdminSliceReducer,{ iGrantAdminState } from "src/store/features/admin/grantAdminSlice";
import resetPasswordSliceReducer, { iResetPasswordState } from "src/store/features/admin/resetPasswordSlice";
import revokeAdminSliceReducer, { iRevokeAdminState } from "src/store/features/admin/revokeAdminSlice";
import createLibrarySliceReducer, { iCreateLibraryState } from "src/store/features/library/createLibrarySlice";
import deleteLibrarySliceReducer, { iDeleteLibraryState } from "src/store/features/library/deleteLibrarySlice";
import renameLibrarySliceReducer, { iRenameLibraryState } from "src/store/features/library/renameLibrarySlice";
import listLibrarySliceReducer, { iListLibraryState } from "src/store/features/library/libraryListSlice";
import dataListSliceReducer, { iDataListState } from "src/store/features/ppi/ppi_data/dataFileLIstSlice";
import uploadAssayCheckSliceReducer, {iAssayCheckState} from "src/store/features/ppi/ppi_file_upload/uploadAssayCheckSlice";
import uploadMoleculeCheckSliceReducer, {iMoleculeCheckState} from "src/store/features/ppi/ppi_file_upload/uploadMoleculeCheckSlice";
import uploadMoleculePresignedSliceReducer, {iMoleculePresignedState} from "src/store/features/ppi/ppi_file_upload/uploadMoleculePresignedSlice";
import existFileCheckSliceReducer, { iExistFileCheckState } from "src/store/features/ppi/ppi_file_upload/existFileCheckSlice";
import userPPiParameterSliceReducer, { iUserPPiParameterState } from "src/store/features/ppi/ppi-user-parameters/ppiUserParametersSlice";
import proteinListSliceReducer, {iProteinListState} from 'src/store/features/ppi/ppi_data/dataProteinNameListSlice'
import sequenceSliceReducer, {iGetSequenceState} from "src/store/features/ppi/ppi_data/dataSequenceSlice";
import ppiVinaSliceReducer, { iPPIVinaState } from "src/store/features/ppi/ppi-vina/ppivinaSlice";
import workFlowRunSliceReducer, { iWorkFlowRunState } from "src/store/features/workflow/workFlowRunSlice";
import updateSliceReducer, { iUpdateUserState } from "src/store/features/user/updateUserInfoSlice";
import workFlowBackupListSliceReducer,{iWorkFlowBackupListState}  from "src/store/features/workflow/workFlowBackupListSlice";
import workFlowResultSliceReducer, {iWorkFlowResultState} from "src/store/features/workflow/workflowResultSlice";
import workFlowStatusSliceReducer, {WorkflowStatusState} from "src/store/features/workflow/workFlowStatusSlice";
import workFlowStopSliceReducer, {iWorkFlowStopState} from "src/store/features/workflow/workFlowStopSlice";
import workFlowResultListSliceReducer, {iWorkflowResultListState} from "src/store/features/ppi/ppi_workflow/workFlowResultListSlice";
import workflowGetLigandSliceReducer, {iWorkFlowGetLigandState} from "src/store/features/ppi/workFlowGetDockingLigandSlice";
import userCSRFTokenSliceReducer, {iUserCSRFTokenState} from 'src/store/features/user/userCSRFTokenSlice';
import loginCheckSliceReducer, {iLoginCheckState} from 'src/store/features/user/login/loginCheckSlice';
import wholeWorkflowSliceReducer,{iWholeWorkflowState} from "src/store/features/dashboard/wholeWorkflowSlice";
import userChoiceHistoryWorkflowSliceReducer , {iUserChoiceHistoryWorkflowState} from "src/store/features/dashboard/userChoiceHistoryWorkflowSlice";
import getKinaseListAPIReducer, {iKinaseListState} from "src/store/features/kinase/dataGetKinaseListSlice";
import getKinaseOffTargetAPIReducer, {iGetKinaseOffTargetState} from "src/store/features/kinase/dataGetKinaseOffTargetSlice";
import getLibraryDetailSliceReducer, { iDetailLibraryDetailState } from "src/store/features/library/libraryDetailSlice";
import getKeyResidueSliceReducer, {iKeyResidueDistanceState} from "src/store/features/ppi/keyResidueDistanceSlice";
import workFlowCheckFilterDiffAPIReducer, {iWorkFlowCheckFilterDiffState} from "src/store/features/workflow/workFlowCheckFilterDiffSlice";
import userKinaseParameterSliceReducer, {iKinaseUserParameterState} from 'src/store/features/kinase/kinase-user-parameters/kinaseUserParameterSlice'
import kinaseVinaSliceReducer, {iKinaseVinaState} from 'src/store/features/kinase/kinase-vina/kinasevinaSlice'
import kinaseUserVinaSliceReducer, {iKinaseUserVinaState} from 'src/store/features/kinase/kinase-vina/kinaseUservinaSlice'
import kinaseSequenceSliceReducer, { iGetKinaseSequenceState } from "src/store/features/kinase/dataKinaseSequenceSlice";
import workflowRunListReducer , {iWorkFlowStepListState} from 'src/store/features/ppi/ppi_workflow/workFlowStepListSlice'
import workflowRankFilterSaveReducer, {iFinalRankFilterSaveState} from "src/store/features/filter/finalRankFilterSaveSlice";
import workflowRankFilterLoadReducer, {iFinalRankFilterLoadState} from "src/store/features/filter/finalRankFilterLoadSlice";
import libraryRoundUpdateSliceReducer, {iLibraryRoundUpdateState} from "src/store/features/library/libraryRoundUpdateSlice";
import commonUserParameterSliceReducer , {iCommonUserParameterState} from "src/store/features/user/commonUserParameterSlice";
import temporarySaveSliceReducer, {iTemporarySaveState} from "src/store/features/temporary/temporarySaveSlice";
import lambdaCallSliceReducer, {iLambdaCallState} from "src/store/features/ppi/ppi_file_upload/lambdaCallSlice";
import lambdaStatusSliceReducer, {iLambdaStatusState} from "src/store/features/ppi/ppi_file_upload/lambdaCallStatusSlice";
import lambdaResultSliceReducer, {iLambdaCallResultState} from "src/store/features/ppi/ppi_file_upload/lambdaCallResultSlice";
import manualResultSliceReducer, {iManualPDFState} from "src/store/features/pdf/manualPDFSlice";
import drugResponseListSliceReducer , {iDrugResponseState} from "src/store/features/drug-response/drugResponseSlice";
import drugScoreSliceReducer , {iDrugScoreState} from "src/store/features/drug-response/drugScoreSlice";
import sortedDataSliceReducer, {iSortedResultState} from "src/store/features/drug-response/sortedResultsSlice";
import modelListSliceReducer , {iModelListState} from "src/store/features/drug-response/modelListSlice";
import creditListSliceReducer, { iCreditAdjustmentsState } from "src/store/features/admin/creditAdjustmentsSlice";
import userCreditBalanceListSliceReducer, { iUserCreditBalanceListState } from "src/store/features/admin/userCreditBalanceListSlice";
import userMyCreditBalanceSliceReducer, { iUserMyBalanceState } from "src/store/features/user/credit/userMyCreditBalanceSlice";
import userMyHeldCreditBalanceSliceReducer,{ iUserMyHeldBalanceState } from "src/store/features/user/credit/userMyHeldCreditBalanceSlice";
import userDrugResponseParameterSliceReducer, {iDrugResponseUserParameterState} from "src/store/features/drug-response/drug-response-user/drugResponseUserParameterSlice";
import userMyCreditBalanceHistorySliceReducer, {iUserMyBalanceHistoryState} from "src/store/features/user/credit/myCreditBalanceHistorySlice";
import cellLineSliceReducer, { iCellLineListState } from "src/store/features/drug-response/cellLineListSlice";
import userMyActivitySliceReducer, {iUserMyActivityState} from "src/store/features/user/userActivitySlice";
import cellLineFilterSaveReducer , {iCellLineFilterSaveState} from "src/store/features/drug-response/cellLineFilterSaveSlice";
import workingBatchListSliceReducer , {iWorkingBatchListState} from 'src/store/features/admin/workingBatchListSlice'
import geneColumListSliceReducer, {iGeneColumnListState} from 'src/store/features/drug-response/getGeneExpressionColumnListSlice';
import adminUserParameterSliceReducer,{ iAdminUSerParameterState } from "src/store/features/admin/admin-user/adminUserParameterSlice";
import emailCheckSliceReducer , {iEmailCheckState} from "src/store/features/admin/emailCheckSlice"
import signupAutoUpdateSliceReducer,{ iSignupAutoUpdateState } from "src/store/features/admin/signupAutoUpdateSlice";
import getSignupAutoUpdateSliceReducer, { iGetSignupAutoUpdateState } from "src/store/features/admin/getSignUpAutoSlice";
import postPasswordResetRequestSliceReducer , {iResetPasswordResetRequestState}  from "src/store/features/user/password/resetPasswordRequestSlice";
import postPasswordResetConfirmSliceReducer, { iResetPasswordConfirmState } from "src/store/features/user/password/resetpasswordConfirmSlice";
import ragQuerySliceReducer, { iRagQueryState } from "src/store/features/rag/ragQuerySlice";
import drugToxicityReducer, { iDrugToxicityState } from "src/store/features/drug-toxicity/drugToxicitySlice";
import mdtrReducer, { iMdtrState } from "src/store/features/mdtr/mdtrSlice";
import userDrugToxicityParameterSliceReducer, { iDrugToxicityUserParameterState } from "src/store/features/drug-toxicity/drug-toxicity-user/drugToxicityUserParameterSlice";
import userMdtrParameterSliceReducer, { iMdtrUserParameterState } from "src/store/features/mdtr/mdtr-user/mdtrUserParameterSlice";
import aiChatActiveCheckSliceReducer, { iAiChatActiveCheckState } from "src/store/features/ai-chat/aiChatActiveCheckSlice";
import biomarkerReducer, { iBiomarkerState } from "src/store/features/biomarker/biomarkerSlice";

export interface IState {
  drawer: iDrawerState;
  appbar: iAppbarState;
  setting: iSettingState;
  assistantDock: iAssistantDockState;
  loginCheck : iLoginState;
  createAccount : iCreateAccountState;
  userInfo : iAuthInfoState,
  updateUserInfo : iUpdateUserState,
  logout : iLogoutState,
  checkAdmin : iCheckAdminState,
  adminUserList : iCheckUserListState,
  activeUser : iConfirmActiveUserState,
  passiveUser : iConfirmPassiveUserState,
  grantUser : iGrantAdminState,
  resetPassword : iResetPasswordState,
  revokeUser : iRevokeAdminState,
  createLibrary : iCreateLibraryState,
  deleteLibrary : iDeleteLibraryState,
  renameLibrary : iRenameLibraryState,
  listLibrary : iListLibraryState,
  dataList : iDataListState,
  assayCheck : iAssayCheckState,
  moleculeCheck : iMoleculeCheckState,
  moleculePresigned : iMoleculePresignedState,
  isFileExist: iExistFileCheckState;
  userParameter : iUserPPiParameterState;
  proteinList : iProteinListState;
  sequenceList : iGetSequenceState;
  ppivina : iPPIVinaState;
  workFlowRun : iWorkFlowRunState;
  workFlowBackupList : iWorkFlowBackupListState;
  workFlowStatus : WorkflowStatusState;  // 수정된 인터페이스 타입
  workFlowStop : iWorkFlowStopState;
  workFlowResult : iWorkFlowResultState;
  workFlowResultList : iWorkflowResultListState;
  workflowGetLigand : iWorkFlowGetLigandState;
  userCSRFToken: iUserCSRFTokenState; // CSRF 토큰 상태 추가
  backLoginCheck: iLoginCheckState; // 로그인 체크 상태 추가
  dashboardHistory: iWholeWorkflowState; // 사용자 선택 이력 상태 추가
  userChoiceHistoryWorkflow: iUserChoiceHistoryWorkflowState; // 사용자 선택 이력 상태 추가
  kinaseList: iKinaseListState; // 키나제 리스트 상태 추가
  getKinaseOffTarget: iGetKinaseOffTargetState; // 키나제 오프 타겟 상태 추가
  libraryDetail : iDetailLibraryDetailState;
  keyResidueDistance : iKeyResidueDistanceState;
  workFlowCheckFilterDiff : iWorkFlowCheckFilterDiffState;
  userKinaseParameter : iKinaseUserParameterState;
  kinasevina : iKinaseVinaState;
  kinaseuservina : iKinaseUserVinaState;
  kinaseSequenceList : iGetKinaseSequenceState;
  workflowRunStatusList : iWorkFlowStepListState;
  workflowFinalRankSave : iFinalRankFilterSaveState;
  workflowFinalRankLoad : iFinalRankFilterLoadState;
  libraryRoundUpdate : iLibraryRoundUpdateState;
  commonUserParameter : iCommonUserParameterState;
  temporarySave : iTemporarySaveState; // 임시 저장 버튼
  lambdaCall : iLambdaCallState;
  lambdaStatus : iLambdaStatusState;
  lambdaResult : iLambdaCallResultState;
  manual : iManualPDFState,
  drugResponse : iDrugResponseState;
  drugScore : iDrugScoreState;
  sortedResult : iSortedResultState;
  modelList : iModelListState;
  creditAdjustment : iCreditAdjustmentsState;
  userBalanceList : iUserCreditBalanceListState;
  userMyCreditBalance : iUserMyBalanceState;
  userMyHeldCreditBalance : iUserMyHeldBalanceState;
  userDrugResponse : iDrugResponseUserParameterState;
  userMyCreditBalanceHistory : iUserMyBalanceHistoryState; // 사용자 크레딧 잔액 이력 추가
  cellLineList : iCellLineListState; // 세포주 리스트 상태 추가
  userMyActivity : iUserMyActivityState; // 사용자 활동 이력 추가
  cellLineFilterSave : iCellLineFilterSaveState; // 세포주 필터 저장 상태 추가
  workingBatchList : iWorkingBatchListState;
  geneColumnList : iGeneColumnListState;
  adminUserParameter : iAdminUSerParameterState;
  emailCheck : iEmailCheckState;
  signupAutoUpdate : iSignupAutoUpdateState;
  getSignAutoUpdate : iGetSignupAutoUpdateState;
  resetPasswordRequest : iResetPasswordResetRequestState;
  resetPasswordConfirm : iResetPasswordConfirmState;
  ragQuery : iRagQueryState;
  drugToxicity : iDrugToxicityState;
  mdtr : iMdtrState;
  userDrugToxicityParameter : iDrugToxicityUserParameterState;
  userMdtrParameter : iMdtrUserParameterState;
  aiChatActiveCheck : iAiChatActiveCheckState;
  biomarker : iBiomarkerState;

}

const rootReducer = (state: IState, action: any): any => {
  switch (action.type) {
    default: {
      const combineReducer = combineReducers({
        drawer: drawerReducer,
        appbar: appbarReducer,
        setting: settingReducer,
        assistantDock: assistantDockReducer,
        loginCheck : logSliceReducer,
        createAccount : createAccountSliceReducer,
        userInfo : userInfoSliceReducer,
        updateUserInfo : updateSliceReducer,
        logout : logoutSliceReducer,
        checkAdmin : checkAdminSliceReducer,
        adminUserList : checkUserSliceReducer,
        activeUser : confirmActiveUserSliceReducer,
        passiveUser : confirmPassiveUserSliceReducer,
        grantUser : grantAdminSliceReducer,
        resetPassword : resetPasswordSliceReducer,
        revokeUser : revokeAdminSliceReducer,
        createLibrary : createLibrarySliceReducer,
        deleteLibrary : deleteLibrarySliceReducer,
        renameLibrary : renameLibrarySliceReducer,
        listLibrary : listLibrarySliceReducer,
        dataList : dataListSliceReducer,
        assayCheck : uploadAssayCheckSliceReducer,
        moleculeCheck : uploadMoleculeCheckSliceReducer,
        moleculePresigned : uploadMoleculePresignedSliceReducer,
        isFileExist: existFileCheckSliceReducer,
        userParameter : userPPiParameterSliceReducer,
        proteinList : proteinListSliceReducer,
        sequenceList : sequenceSliceReducer,
        ppivina : ppiVinaSliceReducer,
        workFlowRun: workFlowRunSliceReducer,
        workFlowBackupList: workFlowBackupListSliceReducer,
        workFlowStatus: workFlowStatusSliceReducer,
        workFlowStop: workFlowStopSliceReducer,
        workFlowResult: workFlowResultSliceReducer,
        workFlowResultList: workFlowResultListSliceReducer,
        workflowGetLigand: workflowGetLigandSliceReducer,
        userCSRFToken: userCSRFTokenSliceReducer, // CSRF 토큰 리듀서 추가
        backLoginCheck: loginCheckSliceReducer, // 로그인 체크 리듀서 추가
        dashboardHistory:wholeWorkflowSliceReducer, // 대시보드 이력 리듀서 추가
        userChoiceHistoryWorkflow: userChoiceHistoryWorkflowSliceReducer, // 사용자 선택 이력 리듀서 추가
        kinaseList: getKinaseListAPIReducer, // 키나제 리스트 리듀서 추가
        getKinaseOffTarget: getKinaseOffTargetAPIReducer, // 키나제 오프 타겟 리듀서 추가
        libraryDetail : getLibraryDetailSliceReducer,
        keyResidueDistance : getKeyResidueSliceReducer,
        workFlowCheckFilterDiff : workFlowCheckFilterDiffAPIReducer,
        userKinaseParameter : userKinaseParameterSliceReducer,
        kinasevina : kinaseVinaSliceReducer,
        kinaseuservina : kinaseUserVinaSliceReducer,
        kinaseSequenceList : kinaseSequenceSliceReducer,
        workflowRunStatusList : workflowRunListReducer,
        workflowFinalRankSave : workflowRankFilterSaveReducer,
        workflowFinalRankLoad : workflowRankFilterLoadReducer,
        libraryRoundUpdate : libraryRoundUpdateSliceReducer,
        commonUserParameter : commonUserParameterSliceReducer,
        temporarySave : temporarySaveSliceReducer,
        lambdaCall : lambdaCallSliceReducer,
        lambdaStatus : lambdaStatusSliceReducer,
        lambdaResult : lambdaResultSliceReducer,
        manual : manualResultSliceReducer,
        drugResponse : drugResponseListSliceReducer,
        drugScore : drugScoreSliceReducer,
        sortedResult : sortedDataSliceReducer,
        modelList : modelListSliceReducer,
        creditAdjustment : creditListSliceReducer,
        userBalanceList : userCreditBalanceListSliceReducer,
        userMyCreditBalance : userMyCreditBalanceSliceReducer,
        userMyHeldCreditBalance : userMyHeldCreditBalanceSliceReducer,
        userDrugResponse : userDrugResponseParameterSliceReducer,
        userMyCreditBalanceHistory : userMyCreditBalanceHistorySliceReducer, // 사용자 크레딧 잔액 이력 리듀서 추가
        cellLineList : cellLineSliceReducer, // 세포주 리스트 리듀서 추가
        userMyActivity : userMyActivitySliceReducer, // 사용자 활동 이력 리듀서 추가
        cellLineFilterSave : cellLineFilterSaveReducer, // 세포주 필터 저장 리듀서 추가
        workingBatchList : workingBatchListSliceReducer, // 실행중인 Batch List 조회 리듀서 추가
        geneColumnList : geneColumListSliceReducer,
        adminUserParameter : adminUserParameterSliceReducer,
        emailCheck : emailCheckSliceReducer,
        signupAutoUpdate : signupAutoUpdateSliceReducer,
        getSignAutoUpdate : getSignupAutoUpdateSliceReducer,
        resetPasswordRequest : postPasswordResetRequestSliceReducer,
        resetPasswordConfirm : postPasswordResetConfirmSliceReducer,
        ragQuery : ragQuerySliceReducer,
        drugToxicity : drugToxicityReducer,
        mdtr : mdtrReducer,
        userDrugToxicityParameter : userDrugToxicityParameterSliceReducer,
        userMdtrParameter : userMdtrParameterSliceReducer,
        aiChatActiveCheck : aiChatActiveCheckSliceReducer,
        biomarker : biomarkerReducer,
      });
      return combineReducer(state, action);
    }
  }
};

export const store = configureStore({
  reducer: rootReducer as Reducer<IState, any>,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
